

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Screenshot from '../../../../../helpers/Screenshot';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';

// Component styles
import { api_host } from '../../../../../common/globals/constants';
import { getMonitorsList } from '../../../../../services/getMonitorsList';

import moment from 'moment'
import 'moment/locale/es'
import { AtCircularProgress } from '../../../../../components/AtCircularProgress';
import { Dialog, Table, TableBody } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class ScreenshotElement extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad: true,
            objective: this.props.objective,
            nodes: this.props.nodes,
            steps: this.props.steps,
            begin: this.props.dateBegin,
            final: this.props.dateFinal,
            dates: null,
            modalOpen:false,
            monitors: this.props.monitors,
            node: this.props.node,
            isEmpty: false,
            service: this.props.service,
            listServicesMobile: [290, 292, 700],
            listServicesScreenshot: [255, 256, 257, 258, 270, 271, 272]
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin !== state.begin || props.dateFinal!==state.final) {
            return {
                isLoad: true,
                begin: props.dateBegin,
                final: props.dateFinal,
                dates: null
            }
        }
        if(props.node!== state.node){
            return {
                isLoad:true,
                nodes: props.nodes,
                monitors: props.monitors,
                node: props.node
            }
        }
        
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log('upd', prevProps.dateBegin.format("YYYY-MM-DD H:mm:ss"), this.state.begin)
        if(prevProps.dateBegin!== this.state.begin || prevProps.dateFinal!== this.state.final||
            prevProps.node !== this.state.node){
            this.processData();
        }
    }
    

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, begin, final, monitores, token, service) =>{
        return new Promise((resolve, reject) => {
            var cdnList = []
            var fetches = []            
            monitores.forEach((value, key)=>{
                var monitor_id=(value)
                var getListScreenshot = fetch(api_host+`/reporte/general/objetivos/${objective}/screenshots/list_images_thumbnail/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitor_id}&service=${service}`)
                        .then( response => response.json())
                fetches.push(                    
                    getListScreenshot.then( dataCdn =>  { 
                            cdnList[key] = dataCdn;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(cdnList);
            })      
        });
    }

   
    processData = () => {
        //console.log('process')
        const { objective, nodes, begin, final, monitors, node, service} = this.state
        let token = sessionStorage.getItem('key')
        let listImage = []
        //let beginTitle = String(event.currentTarget.id).substring(0,19)
        //let endTitle = String(event.currentTarget.id).substring(19,38)
        //let targetEvent = event.currentTarget
        //let currentNode = event.currentTarget.value
        fetch(api_host+`/reporte/online/indicadores/getResultadosObjetivoLigero/?objetivoId=${objective}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&fecha_inicio=${begin}&fecha_termino=${final}&nodoId=${node}`)
                .then(response => response.json())
                .then(myJson => { 
                    //if (target !== event.currentTarget){
                        /*var listMonitor = monitors
                        if (node != 0){
                            listMonitor = []
                            Object(nodes).map(element=>{
                                if (element['id_nodo'] == node){
                                    listMonitor.push(element['monitor'])
                                }
                            })
                        }*/
                        var listMonitor = []
                        var getData = getMonitorsList(objective, begin, final, token)       
                        getData.then( data =>  { 
                            var indexRemove = 0
                            Object.values(data).map((item, index) => { 
                                if (item.id_nodo == 0){
                                    indexRemove = index
                                }
                            })
                            let remove = data.splice(indexRemove, 1)
                            if (data.length > 0 ){
                                Object(data).map(element=>{
                                    listMonitor.push(element['monitor'])
                                })
                            }
                            if (node != 0){
                                listMonitor = []
                                Object(data).map(element=>{
                                    if (element['id_nodo'] == node){
                                        listMonitor.push(element['monitor'])
                                    }
                                })
                            }
                            var listDates = []
                            let nodesStatus = myJson.Objetivo?.Nodo ?? []
                            var fetchListScreenshot = this.getFetchs(objective, begin, final, listMonitor, token, service)
                            
                            fetchListScreenshot.then( value =>{
                                Object(value).map(element=>{
                                    if (element.length > 0){
                                        Object(element).map(data=>{
                                            listImage.push(data)
                                        })
                                    }
                                })
                                var isEmpty = false
                                var contimages = 0
                                if (listImage.length > 0) {
                                
                                    listImage.sort(function (a, b) {
                                        const aDate = new Date(a.fecha_creacion)
                                        const bDate = new Date(b.fecha_creacion)
                                        return bDate.getTime() - aDate.getTime()
                                    });
                                    Object(listImage).map(element=>{
                                        Object(data).map(node=>{
                                            if(node['monitor'] == element['monitor_id']){
                                                element['nodo'] = node['nodo']
                                                Object(nodesStatus).map(nodeStatus=>{
                                                    if (nodeStatus['nodo_id'] == node['id_nodo']){
                                                        let listStatus = []
                                                        let listPattern = []
                                                        let listStep = []
                                                        let listStepId = []
                                                        var index = 0
                                                        Object(nodeStatus['Paso']).map(stepStatus=>{
                                                            var pattern = null
                                                            Object(stepStatus['Eventos']).map(eventStatus=>{
                                                                pattern = eventStatus.patron
                                                                const dateEventStatus = new Date(eventStatus.fecha.substring(0,19))
                                                                const dateElement = new Date(element.fecha_creacion)
                                                                if (dateElement.getTime() - dateEventStatus.getTime() > -1000){
                                                                    listStatus[index] = eventStatus['código_tipo']
                                                                }
                                                            })
                                                            listPattern.push(pattern)
                                                            listStep.push(stepStatus['paso_nombre'])
                                                            listStepId.push(stepStatus['orden'])
                                                            index = index + 1
                                                        })
                                                        element['pattern'] = listPattern
                                                        element['status'] = listStatus
                                                        element['steps'] = listStep
                                                        element['stepsId'] = listStepId
                                                    }
                                                })
                                            }
                                        })
                                    })
                                    Object(listImage).map(element=>{
                                        var listImageToken = []
                                        var listColorStatus = []
                                        var listStepsWithScreenshots = []
                                        var listStepsIdWithScreenshots = []
                                        var listPatternWithScreenshot = []
                                        var listTokenSteps = []
                                        Object(element['img_token']).map((imgToken, key)=>{
                                            var color = ''
                                            if (imgToken != 'NULL'){
                                                Object(element['stepsId']).map((stepId, orden)=>{
                                                    if(stepId == key) {
                                                        const byteCharacters = atob(element['img_token'][key]);
                                                        const byteNumbers = new Array(byteCharacters.length);
                                                        for (let i = 0; i < byteCharacters.length; i++) {
                                                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                        }
                                                        const byteArray = new Uint8Array(byteNumbers);
                    
                                                        let image = new Blob([byteArray], { type: 'image/jpeg' });
                                                        let imageUrl = URL.createObjectURL(image);
                                                        listImageToken.push(imageUrl)
                                                        if(element['status'][orden] == 0){
                                                            color = '#A9A9A9'
                                                        }else if(element['status'][orden] == 1) {
                                                            color = '#41B900'
                                                        }else if(element['status'][orden] == 2) {
                                                            color = '#C2272D'
                                                        }
                                                        listColorStatus.push(color)
                                                        listStepsWithScreenshots.push(element['steps'][orden])
                                                        listStepsIdWithScreenshots.push(element['stepsId'][orden])
                                                        listPatternWithScreenshot.push(element['pattern'][orden])
                                                        listTokenSteps.push(element['tokens'][key])
                                                    }
                                                })
                                                

                                                
                                            } /*else {
                                                element['steps'].splice(key, 1)
                                            }*/
                                            
                                        })
                                        element['images'] = listImageToken
                                        element['color'] = listColorStatus
                                        element['stepsWithScreenshots'] = listStepsWithScreenshots
                                        element['stepsIdWithScreenshots'] = listStepsIdWithScreenshots
                                        element['tokenSteps'] = listTokenSteps
                                        element['patternWithScreenshot'] = listPatternWithScreenshot
                                        if (listImageToken.length == 0){
                                            contimages = contimages + 1
                                        }
                                    })
                                } else {
                                    isEmpty = true
                                }
                                if (contimages == listImage.length){
                                    isEmpty = true
                                }
                                this.props.callbackFromParent(true)
                                this.setState({ isOpen: !this.state.isOpen,
                                                //target: targetEvent,
                                                currentDate: begin,
                                                //currentNode: currentNode,
                                                isEmpty: isEmpty,
                                                listImage: listImage,
                                                isLoad: false,
                                                dates: value});
                            })
                        })
                })
        
    }

    setOpen = ( ele, tokenPicture, stepToken, dateBeginScreenshot, pattern) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            tokenPicture : tokenPicture,
            stepToken : stepToken,
            nameStep : ele,
            dateBeginScreenshot: dateBeginScreenshot,
            pattern: pattern
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true
        })
    }

    render() {

        const { isLoad, dates, steps, objective, image, listImage, modalOpen, isEmpty, listServicesMobile, listServicesScreenshot, service} = this.state;
        const { classes } = this.props;
        var style = {borderTop: '1px solid #ddd', borderRadius: '4px', padding: '5px', height:'150px', width:'194px'} 
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (listServicesMobile.includes(service)){
            style = {borderTop: '1px solid #ddd', borderRadius: '4px', padding: '5px', height:'150px'} 
        }
        const selectedColor = this.props.selectedColor || 'all';
        if (isLoad===true) {
            return(
                <AtCircularProgress />
            )
        }else{
            return(
                <PortletContent style={{textAlign: 'center', padding: 0}}>
                    {isEmpty ? (
                        <Typography variant="body1" align="center">
                            {this.props.t('screenshots-rebuild.no-screenshots')}
                        </Typography>
                    ) : (
                        listImage.map(element => {
                            // 1. Buscamos qué índices de imagen coinciden con el color seleccionado
                            const filteredIndices = element['images']
                                .map((_, index) => {
                                    if (selectedColor === 'all' || element['color'][index] === selectedColor) {
                                        return index;
                                    }
                                    return null;
                                })
                                .filter(index => index !== null);

                            // 2. Si este registro no tiene ninguna imagen del color filtrado, no renderizamos el bloque
                            if (filteredIndices.length === 0) return null;

                            return (
                                <div key={element['nodo'] + '    ' + element['fecha_creacion'].replace('T', ' ')}>
                                    <PortletHeader style={{fontFamily:'Roboto', backgroundColor: '#0b1738', color: 'white'}}>
                                        {element['nodo'] + '    ' + element['fecha_creacion'].replace('T', ' ')}
                                    </PortletHeader>
                                    <PortletContent style={{backgroundColor: '#f1f1f1', padding: 0, overflowX: 'auto'}}>
                                        <Table>
                                            <TableBody>
                                                <TableRow style={{ textOverflow: 'ellipsis', whiteSpace: "normal", wordWrap: "break-word" }}>
                                                    {/* 3. Mapeamos solo los índices que coinciden con el filtro */}
                                                    {filteredIndices.map(key => (
                                                        <TableCell key={element['tokenSteps'][key]}>
                                                            <Button onClick={() => {
                                                                this.setOpen(
                                                                    element['stepsWithScreenshots'][key], 
                                                                    element['tokenSteps'][key], 
                                                                    element['stepsIdWithScreenshots'][key], 
                                                                    element['fecha_creacion'], 
                                                                    element['patternWithScreenshot'][key]
                                                                );
                                                            }}>
                                                                <div style={{ border: '1px solid #ddd', width: '214px', boxSizing: 'border-box', overflow: 'hidden' }}>
                                                                    <Typography 
                                                                        style={{
                                                                            backgroundColor: element['color'][key], 
                                                                            color: 'white', 
                                                                            padding: '5px',
                                                                            width: '100%',               // Ocupa exactamente el ancho del div padre
                                                                            boxSizing: 'border-box',     // Incluye el padding en el cálculo del ancho
                                                                            wordBreak: 'break-word',     // Rompe palabras largas si no caben
                                                                            textAlign: 'center'
                                                                        }}
                                                                    >
                                                                        {element['stepsWithScreenshots'][key]}
                                                                    </Typography>
                                                                    <img 
                                                                        style={{
                                                                            ...style, 
                                                                            width: '100%',               // Ajusta la imagen al ancho del contenedor
                                                                            display: 'block'             // Elimina espacios en blanco inferiores por defecto de las imágenes
                                                                        }} 
                                                                        src={element['images'][key]} 
                                                                        alt="screenshot" 
                                                                    />
                                                                </div>
                                                            </Button>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </PortletContent>
                                </div>
                            );
                        })
                    )}
                    {/*isEmpty ? <Typography
                                    variant="body1"
                                    align="center"
                                >
                                     {this.props.t('screenshots-rebuild.no-screenshots')}</Typography>
                        
                    :listImage.map(element=>{
                        if(element['images'].length > 0){
                            return(
                                <div key={element['nodo']+'    '+element['fecha_creacion'].replace('T',' ')}>
                                    <PortletHeader style={{fontFamily:'Roboto', backgroundColor: '#0b1738', color: 'white'}}>
                                        {element['nodo']+'    '+element['fecha_creacion'].replace('T',' ')}
                                    </PortletHeader>
                                    <PortletContent style={{backgroundColor: '#f1f1f1', padding: 0, overflowX: 'auto'}}>
                                        <Table>
                                            <TableBody>
                                                <TableRow
                                                        style={{textOverflow: 'ellipsis',
                                                        whiteSpace: "normal",
                                                        wordWrap: "break-word",
                                                    }}
                                                    >
                                                        {element['images'].map((image, key)=>(
                                                            <TableCell key={element['tokenSteps'][key]}>
                                                                <Button onClick={(e)=>{this.setOpen(element['stepsWithScreenshots'][key], element['tokenSteps'][key], element['stepsIdWithScreenshots'][key], element['fecha_creacion'], element['patternWithScreenshot'][key])}}>
                                                                    <div style={{border: '1px solid #ddd', width: '214px'}}>
                                                                        <Typography style={{backgroundColor: element['color'][key], color:'white', padding: '5px'}}>{element['stepsWithScreenshots'][key]}</Typography>
                                                                        <img style={style} src={image} />
                                                                    </div>
                                                                </Button>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                            </TableBody>
                                        </Table>
                                    </PortletContent>
                                </div>
                            )
                        }
                    })*/}
                    <Dialog
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpen}
                        onClose={this.setCloseModal}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                        PaperProps={{
                            style: {
                                margin: 4,
                            }
                        }}
                    >
                        <Fade in={modalOpen}>
                            <Screenshot data = {this.state}  onClose={this.setCloseModal}/>
                        </Fade>
                    </Dialog>
                </PortletContent>
            )
        }
    }
}



export default compose(withRouter, withStyles(styles), withTranslation())(ScreenshotElement);